import { IconButton, TextField } from "@mui/material";
import styled from "styled-components";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useTranslation } from "react-i18next";

const StyledQtyButtonWrapper = styled.div`
  display: flex;
  .subtract-button {
    line-height: 45px;
  }

  .qty-input-field {
    width: 70px;
    padding: 0px 10px;
    color: black;

    .MuiInput-root,
    .MuiInputLabel-root,
    input {
      color: black;
      -webkit-text-fill-color: rgba(0, 0, 0, 1);
    }
  }

  .add-button {
    line-height: 45px;
  }
`;

const QtyField = ({ onChange, value, allowNullValue }) => {
  const { t } = useTranslation();
  const lowestValue = allowNullValue ? 0 : 1;
  const highestValue = 25;

  const handleOnChange = (value) => {
    const newValue = isNaN(value) ? lowestValue : value;
    if (onChange)
      onChange(Math.min(highestValue, Math.max(newValue, lowestValue)));
  };
  const handleButton = (idx) => handleOnChange(value + idx);

  return (
    <StyledQtyButtonWrapper>
      <div className="subtract-button">
        <IconButton
          color="primary"
          disabled={value <= lowestValue}
          aria-label="Trekk fra"
          onClick={() => handleButton(-1)}
        >
          <RemoveCircleOutlineIcon />
        </IconButton>
      </div>
      <div className="qty-input-field">
        <TextField
          size="small"
          variant="standard"
          label={t("Antall")}
          onChange={(event) => handleOnChange(parseInt(event.target.value))}
          value={value}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </div>
      <div className="add-button">
        <IconButton
          color="primary"
          disabled={value >= highestValue}
          aria-label="Legg til"
          onClick={() => handleButton(1)}
        >
          <AddCircleOutlineIcon />
        </IconButton>
      </div>
    </StyledQtyButtonWrapper>
  );
};

export default QtyField;
